import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { PatientAppointmentApi } from '../api/patient-appointment.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientAppointmentData, PatientAppointment } from '../../../interfaces/patient-services/patient-appointment';
import { Visit } from '../../../interfaces/ehr/visit';

@Injectable()
export class PatientAppointmentService extends PatientAppointmentData {

  private postPatAptData = new BehaviorSubject<PatientAppointment[]>([]);
  public patAptData$ = this.postPatAptData.asObservable();
  
  constructor(private api: PatientAppointmentApi) {
    super();
  }


  list(url: string): Observable<PatientAppointment[]> {
    return this.api.list(url);
  }

  getPatientBookedPastAppts(url: string): Observable<any> {
    return this.api.getPatientBookedPastAppts(url);
  }

  
  AlllistForMenu(url: string): Observable<PatientAppointment[]> {
    return this.api.list(url);
  }
  getById(url: string): Observable<PatientAppointment> {
    return this.api.getById(url);
  }
  getSlots(url: string): Observable<any> {
    return this.api.getSlots(url);
  }

  create(url: string, data:PatientAppointment): Observable<PatientAppointment> {
    return this.api.add(url,data);
  }

  createApptVisit(url: string, data:PatientAppointment): Observable<Visit> {
    return this.api.addApptVisit(url,data);
  }

  createAppointment(url: string, data:PatientAppointment): Observable<any> {
    return this.api.createAppointment(url,data);
  }

  bulkUpdate(url: string, data:PatientAppointment): Observable<PatientAppointment> {
    return this.api.add(url,data);
  }

  update(url: string, data:PatientAppointment): Observable<PatientAppointment[]> {
    return this.api.update(url,data);
  }

  
  searchList(url: string,data:any): Observable<any> {
    return this.api.searchList(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url); 
  }

  cancelApt(url: string,data:any): Observable<boolean> {
    return this.api.cancelApt(url,data); 
  }

  changePatAptList(data: PatientAppointment[]): void{
    this.postPatAptData.next(data);
  }
  patch(url: string, data): Observable<any> {
    return this.api.patch(url,data);
  }
}
